const generateCode = (text: string) => {
    return text.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "")?.replace(/[đĐ]/g, m => m === 'đ' ? 'd' : 'D').toUpperCase();
}
export default generateCode;
